// import { ChainId } from '@pancakeswap-libs/sdk';
import { ChainId } from '@spookyswap/sdk';
import { Configuration } from './tomb-finance/config';
import { BankInfo } from './tomb-finance';

import { http, createConfig } from 'wagmi'
import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import {
  rainbowWallet,
  walletConnectWallet,
  coinbaseWallet,
  injectedWallet,
  metaMaskWallet,
  safeWallet,
  trustWallet,
  rabbyWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { AutoCompounderInfo, DaasInfo } from './tomb-finance/types';

export const soneiumTestnet = {
  id: 146,
  name: 'Sonic',
  nativeCurrency: { name: 'Sonic', symbol: 'S', decimals: 18 },
  rpcUrls: {
    default: {
      http: [
        'https://rpc.soniclabs.com',
        'https://sonic.drpc.org',
        'https://sonic-rpc.publicnode.com',
      ]
    },
  },
  blockExplorers: {
    default: { name: 'Sonicscan', url: 'https://sonicscan.org' },
  },
}

const connectors = connectorsForWallets(
  [
    {
      groupName: 'Recommended',
      wallets: [
        rabbyWallet,
        metaMaskWallet,
        rainbowWallet,
        // walletConnectWallet,
        coinbaseWallet,
        injectedWallet,
        safeWallet,
        trustWallet,
      ],
    },
  ],
  {
    appName: 'Snake Finance',
    projectId: 'YOUR_PROJECT_ID',
  }
);

export const configWagmi = createConfig({
  chains: [soneiumTestnet],
  ssr: true,
  connectors,
  transports: {
    [soneiumTestnet.id]: http(),
  },
})

const configurations: { [env: string]: Configuration } = {
  production: {
    chainId: 146,
    networkName: 'Fantom Opera Testnet',
    ftmscanUrl: 'https://sonicscan.org',
    providers: ['https://rpc.testnet.fantom.network/'],
    deployments: require('./tomb-finance/deployments/deployments.testing.json'),
    externalTokens: {
      FUSDT: ['0xb7f24e6e708eabfaa9e64b40ee21a5adbffb51d6', 6],
      BOO: ['0x14f0C98e6763a5E13be5CE014d36c2b69cD94a1e', 18],
      ZOO: ['0x2317610e609674e53D9039aaB85D8cAd8485A7c5', 0],
      SHIBA: ['0x39523112753956d19A3d6a30E758bd9FF7a8F3C0', 9],
      'USDT-OS-LP': ['0xE7e3461C2C03c18301F66Abc9dA1F385f45047bA', 18],
      'HOG-S-LP': ['0x5505f80099d259d1c6f6feceb7512278eb33ed2f', 18],
      'GHOG-OS-LP': ['0xD1CB1622a50506F0fDdf329CB857a0935C7FbbF9', 18],
    },
    baseLaunchDate: new Date('2021-06-02 13:00:00Z'),
    bondLaunchesAt: new Date('2020-12-03T15:00:00Z'),
    masonryLaunchesAt: new Date('2020-12-11T00:00:00Z'),
    refreshInterval: 10000,
  },
  development: {
    chainId: 146,
    networkName: 'Sonic',
    ftmscanUrl: 'https://sonicscan.org',
    providers: [
      'https://rpc.soniclabs.com',
      'https://sonic.drpc.org',
      'https://sonic-rpc.publicnode.com',
    ],
    deployments: require('./tomb-finance/deployments/deployments.mainnet.json'),
    externalTokens: {

      "HOG-OS": ['0x784dd93f3c42dcbf88d45e6ad6d3cc20da169a60', 18],
      "HOG-OS-LP": ['0x784dd93f3c42dcbf88d45e6ad6d3cc20da169a60', 18],
      "OS": ['0xb1e25689D55734FD3ffFc939c4C3Eb52DFf8A794', 18],
      "ANON": ['0x79bbF4508B1391af3A0F4B30bb5FC4aa9ab0E07C', 18],
      "SWPx": ['0xA04BC7140c26fc9BB1F36B1A604C7A5a88fb0E70', 18],
      "stS": ['0xE5DA20F15420aD15DE0fa650600aFc998bbE3955', 18],
      "scUSD": ['0xd3dce716f3ef535c5ff8d041c1a41c3bd89b97ae', 6],
      "MCLB": ['0x44E23B1F3f4511b3a7e81077Fd9F2858dF1B7579', 18],
      "INDI": ['0x4EEC869d847A6d13b0F6D1733C5DEC0d1E741B4f', 18],

      "HOGOS_ac": ['0x95857D206f12384913B90dD88257A35901F3651D', 18],
      "GHOGOS_ac": ['0xbB501dC65DEEbccff621f5688E6dc417dAa43B04', 18],


      HOG: ['0xB3804bF38bD170ef65b4De8536d19a8e3600C0A9', 18],
      GHOG: ['0x0e899dA2aD0817ed850ce68f7f489688E4D42D9D', 18],
      BHOG: ['0x10c3F87e6af1acAbb6f9A6AEdc5e5d897F683C24', 18],


      "HOG_OS_LP": ['0x784dd93f3c42dcbf88d45e6ad6d3cc20da169a60', 18],
      "GHOG_OS_LP": ['0xd1cb1622a50506f0fddf329cb857a0935c7fbbf9', 18],

      S: ['0x039e2fB66102314Ce7b64Ce5Ce3E5183bc94aD38', 18],
      "wS": ["0x039e2fB66102314Ce7b64Ce5Ce3E5183bc94aD38", 18],
      "USDC.e": ["0x29219dd400f2Bf60E5a23d13Be72B486D4038894", 6],
      "WETH": ["0x50c42dEAcD8Fc9773493ED674b675bE577f2634b", 18],
      "SHADOW": ["0x3333b97138D4b086720b5aE8A7844b1345a33333", 18],
      "GOGLZ": ["0x9fdbc3f8abc05fa8f3ad3c17d2f806c1230c4564", 18],
      "Beets": ["0x2D0E0814E62D80056181F5cd932274405966e4f0", 18],

      'HOG-S-LP': ['0x784dd93f3c42dcbf88d45e6ad6d3cc20da169a60', 18],
      'GHOG-OS-LP': ['0xD1CB1622a50506F0fDdf329CB857a0935C7FbbF9', 18],
    },
    baseLaunchDate: new Date('2025-02-08T18:00:00Z'),
    bondLaunchesAt: new Date('2025-02-15T20:00:00Z'),
    masonryLaunchesAt: new Date('2025-02-15T20:00:00Z'),
    refreshInterval: 10000,
  },
};

export const bankDefinitions: { [contractName: string]: BankInfo } = {
  /*
  Explanation:
  name: description of the card
  poolId: the poolId assigned in the contract
  sectionInUI: way to distinguish in which of the 3 pool groups it should be listed
        - 0 = Single asset stake pools
        - 1 = LP asset staking rewarding HOG
        - 2 = LP asset staking rewarding GHOG
  contract: the contract name which will be loaded from the deployment.environmnet.json
  depositTokenName : the name of the token to be deposited
  earnTokenName: the rewarded token
  finished: will disable the pool on the UI if set to true
  sort: the order of the pool
  */
  "HOGOSRewardPoolGenesis": {
    "name": "Deposit HOG-OS to earn HOG",
    "poolId": 0,
    "sectionInUI": 0,
    "contract": "HogGenesisRewardPool",
    "depositTokenName": "HOG-OS-LP",
    "earnTokenName": "HOG",
    "token1Name": "HOG",
    "token2Name": "OS",
    "finished": false,
    "sort": 0,
    "closedForStaking": false,
    "depositTokenFrom": "SHADOW",
    "isGenesis": false,
    "depositFee": "0",
    "allocPoint": 0,
    "stableAeroPool": true,
    "rewardTokens": [
      "HOG"
    ]
  },
  "OSRewardPoolGenesis": {
    "name": "Deposit OS to earn HOG",
    "poolId": 1,
    "sectionInUI": 0,
    "contract": "OSRewardPoolGenesis",
    "depositTokenName": "OS",
    "earnTokenName": "HOG",
    "token1Name": "OS",
    "token2Name": "OS",
    "finished": false,
    "sort": 1,
    "closedForStaking": false,
    "depositTokenFrom": "SHADOW",
    "isGenesis": true,
    "depositFee": "1",
    "allocPoint": 0,
    "rewardTokens": [
      "HOG"
    ]
  },
  "ANONRewardPoolGenesis": {
    "name": "Deposit ANON to earn HOG",
    "poolId": 2,
    "sectionInUI": 0,
    "contract": "ANONRewardPoolGenesis",
    "depositTokenName": "ANON",
    "earnTokenName": "HOG",
    "token1Name": "ANON",
    "token2Name": "ANON",
    "finished": false,
    "sort": 7,
    "closedForStaking": false,
    "depositTokenFrom": "SHADOW",
    "isGenesis": true,
    "depositFee": "1",
    "allocPoint": 0,
    "rewardTokens": [
      "HOG"
    ]
  },
  "MCLBRewardPoolGenesis": {
    "name": "Deposit MCLB to earn HOG",
    "poolId": 3,
    "sectionInUI": 0,
    "contract": "MCLBRewardPoolGenesis",
    "depositTokenName": "MCLB",
    "earnTokenName": "HOG",
    "token1Name": "MCLB",
    "token2Name": "MCLB",
    "finished": false,
    "sort": 3,
    "closedForStaking": false,
    "depositTokenFrom": "SHADOW",
    "isGenesis": true,
    "depositFee": "1",
    "allocPoint": 3,
    "rewardTokens": [
      "HOG"
    ]
  },
  "SWPxRewardPoolGenesis": {
    "name": "Deposit SWPx to earn HOG",
    "poolId": 4,
    "sectionInUI": 0,
    "contract": "SWPxRewardPoolGenesis",
    "depositTokenName": "SWPx",
    "earnTokenName": "HOG",
    "token1Name": "SWPx",
    "token2Name": "SWPx",
    "finished": false,
    "sort": 3,
    "closedForStaking": false,
    "depositTokenFrom": "SHADOW",
    "isGenesis": true,
    "depositFee": "1",
    "allocPoint": 4,
    "rewardTokens": [
      "HOG"
    ]
  },
  "stSRewardPoolGenesis": {
    "name": "Deposit stS to earn HOG",
    "poolId": 5,
    "sectionInUI": 0,
    "contract": "stSRewardPoolGenesis",
    "depositTokenName": "stS",
    "earnTokenName": "HOG",
    "token1Name": "stS",
    "token2Name": "stS",
    "finished": false,
    "sort": 5,
    "closedForStaking": false,
    "depositTokenFrom": "SHADOW",
    "isGenesis": true,
    "depositFee": "1",
    "allocPoint": 9,
    "rewardTokens": [
      "HOG"
    ]
  },
  "scUSDRewardPoolGenesis": {
    "name": "Deposit scUSD to earn HOG",
    "poolId": 6,
    "sectionInUI": 0,
    "contract": "scUSDRewardPoolGenesis",
    "depositTokenName": "scUSD",
    "earnTokenName": "HOG",
    "token1Name": "scUSD",
    "token2Name": "scUSD",
    "finished": false,
    "sort": 4,
    "closedForStaking": false,
    "depositTokenFrom": "SHADOW",
    "isGenesis": true,
    "depositFee": "1",
    "allocPoint": 6,
    "rewardTokens": [
      "HOG"
    ]
  },
  "INDIRewardPoolGenesis": {
    "name": "Deposit INDI to earn HOG",
    "poolId": 7,
    "sectionInUI": 0,
    "contract": "INDIRewardPoolGenesis",
    "depositTokenName": "INDI",
    "earnTokenName": "HOG",
    "token1Name": "INDI",
    "token2Name": "INDI",
    "finished": false,
    "sort": 9,
    "closedForStaking": false,
    "depositTokenFrom": "SHADOW",
    "isGenesis": true,
    "depositFee": "1",
    "allocPoint": 7,
    "rewardTokens": [
      "HOG"
    ]
  },
  "GOGLZRewardPoolGenesis": {
    "name": "Deposit GOGLZ to earn HOG",
    "poolId": 8,
    "sectionInUI": 0,
    "contract": "GOGLZRewardPoolGenesis",
    "depositTokenName": "GOGLZ",
    "earnTokenName": "HOG",
    "token1Name": "GOGLZ",
    "token2Name": "GOGLZ",
    "finished": false,
    "sort": 9,
    "closedForStaking": false,
    "depositTokenFrom": "SHADOW",
    "isGenesis": true,
    "depositFee": "1",
    "allocPoint": 7,
    "rewardTokens": [
      "HOG"
    ]
  },
  "BeetsRewardPoolGenesis": {
    "name": "Deposit Beets to earn HOG",
    "poolId": 9,
    "sectionInUI": 0,
    "contract": "BeetsRewardPoolGenesis",
    "depositTokenName": "Beets",
    "earnTokenName": "HOG",
    "token1Name": "Beets",
    "token2Name": "Beets",
    "finished": false,
    "sort": 9,
    "closedForStaking": false,
    "depositTokenFrom": "SHADOW",
    "isGenesis": true,
    "depositFee": "1",
    "allocPoint": 7,
    "rewardTokens": [
      "HOG"
    ]
  },

  /* NORMAL FARMS */
  "HogOsRewardPool": {
    "name": "Earn GHOG by HOG-OS LP",
    "poolId": 0,
    "sectionInUI": 2,
    "contract": "CemeteryHogOsRewardPool",
    "depositTokenName": "HOG-OS-LP",
    "earnTokenName": "GHOG",
    "token1Name": "HOG",
    "token2Name": "OS",
    "finished": false,
    "sort": 0,
    "closedForStaking": false,
    "depositTokenFrom": "SHADOW",
    "isGenesis": false,
    "depositFee": "0",
    "allocPoint": 0,
    "stableAeroPool": true,
    "rewardTokens": [
      "GHOG"
    ],
    "psmFeeEnabled": true,
    "hasPsmFee": true
  },
  "GHogOsRewardPool": {
    "name": "Earn GHOG by GHOG-OS LP",
    "poolId": 1,
    "sectionInUI": 2,
    "contract": "CemeteryGHogOsRewardPool",
    "depositTokenName": "GHOG-OS-LP",
    "earnTokenName": "GHOG",
    "token1Name": "GHOG",
    "token2Name": "OS",
    "finished": false,
    "sort": 1,
    "closedForStaking": false,
    "depositTokenFrom": "SHADOW",
    "isGenesis": false,
    "depositFee": "0",
    "allocPoint": 0,
    "rewardTokens": [
      "GHOG"
    ],
    "psmFeeEnabled": true,
    "hasPsmFee": true
  },
};

export const autoCompounderDefinitions: { [contractName: string]: AutoCompounderInfo } = {
  HogAutocompounder: {
    name: 'HogAutocompounder',
    poolId: 0,
    sectionInUI: 4,
    contract: 'HogAutocompounder',
    depositTokenName: 'HOG-OS-LP',
    earnTokenName: 'GHOG',
    vaultContract: 'HogVaultAutocompounder',
    autocompounderContract: 'HogAutocompounder',
    masterChefContract: 'CemeteryHogOsRewardPool',
    pairTokenName1: 'HOG',
    pairTokenName2: 'OS',
    linkVault: '0x95857D206f12384913B90dD88257A35901F3651D',
    linkCompounder: '0xA5dFe9fB3E56845c31cd9C086a604aD86cb57e52',
    compounderContract: 'HogAutocompounder',
    finished: false,
    sort: 8,
    closedForStaking: false,
  },
  GHogAutocompounder: {
    name: 'GHogAutocompounder',
    poolId: 1,
    sectionInUI: 4,
    contract: 'GHogAutocompounder',
    depositTokenName: 'GHOG-OS-LP',
    earnTokenName: 'GHOG',
    vaultContract: 'GHogVaultAutocompounder',
    autocompounderContract: 'GHogAutocompounder',
    masterChefContract: 'CemeteryGHogOsRewardPool',
    pairTokenName1: 'GHOG',
    pairTokenName2: 'OS',
    linkVault: '0xbB501dC65DEEbccff621f5688E6dc417dAa43B04',
    linkCompounder: '0x05974c4fD29c05906cE08891DE502AEb859FCCc8',
    compounderContract: 'GHogAutocompounder',
    finished: false,
    sort: 8,
    closedForStaking: false,
  },
}

export const daasPageMap: { [path: string]: string } = {
  aidensgarden: 'Covenant',
  aidensgardenghog: 'CovenantGHog',
}

export const daasDefinitions: { [contractName: string]: DaasInfo } = {
  Covenant: {
    name: 'Covenant',
    contract: 'Covenant',
    farmerContract: 'CovenantFarmer',
    farmContract: 'CemeteryHogOsRewardPool',
    multicallContract: 'CovenantMultiCall',
    tokenName: 'HOG-OS-LP',
    tokenImage: 'HOG',
    backgroundVideo: 'covenant.mp4',
    // bannerImage: 'splinterlands-banner.jpg',
    // bannerUrl: 'https://bit.ly/SPLINTERLANDS-EMP',
    docs: 'https://hand-of-god.gitbook.io/hand-of-god/protocol/aidens-garden',
    startTimestamp: 1742918400,
    active: true,
  },
  CovenantGHog: {
    name: 'Covenant GHog',
    contract: 'CovenantGHog',
    farmerContract: 'CovenantGHogFarmer',
    farmContract: 'CemeteryGHogOsRewardPool',
    multicallContract: 'CovenantGHogMultiCall',
    tokenName: 'GHOG-OS-LP',
    tokenImage: 'GHOG',
    backgroundVideo: 'covenant.mp4',
    docs: 'https://hand-of-god.gitbook.io/hand-of-god/protocol/aidens-garden',
    startTimestamp: 1743638400,
    active: true,
  },
}

export default configurations['development'];
// export default configurations[process.env.NODE_ENV || 'development'];
